import axios from "axios";

export const customAxios = axios.create({
    baseURL: window.runtimeConfig.API_URL,
});
